// Shared brand-styled markdown renderer (legal pages + blog articles).
import React from "react";
import { Link } from "react-router-dom";
import ReactMarkdown, { defaultUrlTransform } from "react-markdown";
import remarkGfm from "remark-gfm";

export const MD_COMPONENTS = {
  h1: ({ children }) => <h1 className="font-display text-4xl font-medium tracking-tight text-[#F4F1EA]">{children}</h1>,
  h2: ({ children }) => <h2 className="mt-8 font-display text-xl text-[#D4AF37]">{children}</h2>,
  h3: ({ children }) => <h3 className="mt-6 font-display text-lg text-[#F4F1EA]">{children}</h3>,
  p: ({ children }) => <p className="mt-3 text-sm leading-relaxed text-[#C8C2B5]">{children}</p>,
  ul: ({ children }) => <ul className="mt-3 list-disc space-y-1.5 pl-5 text-sm leading-relaxed text-[#C8C2B5]">{children}</ul>,
  ol: ({ children }) => <ol className="mt-3 list-decimal space-y-1.5 pl-5 text-sm leading-relaxed text-[#C8C2B5]">{children}</ol>,
  li: ({ children }) => <li className="pl-1">{children}</li>,
  strong: ({ children }) => <strong className="font-semibold text-[#F4F1EA]">{children}</strong>,
  hr: () => <hr className="my-8 border-[#2B241B]" />,
  table: ({ children }) => (
    <div className="mt-3 overflow-x-auto rounded-xl border border-[#2B241B]">
      <table className="w-full text-left text-sm text-[#C8C2B5]">{children}</table>
    </div>
  ),
  thead: ({ children }) => <thead className="bg-[#1a1509] text-[#D4AF37]">{children}</thead>,
  th: ({ children }) => <th className="px-4 py-2.5 font-display font-medium">{children}</th>,
  td: ({ children }) => <td className="border-t border-[#2B241B] px-4 py-2.5 align-top leading-relaxed">{children}</td>,
  a: ({ href, children }) =>
    href?.startsWith("/") ? (
      <Link to={href} className="text-[#D4AF37] underline decoration-[#3D3428] underline-offset-2 hover:text-[#E5C158]">{children}</Link>
    ) : (
      <a href={href} className="text-[#D4AF37] underline decoration-[#3D3428] underline-offset-2 hover:text-[#E5C158]">{children}</a>
    ),
};

export function Markdown({ children }) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      urlTransform={(url) => (url.startsWith("tel:") ? url : defaultUrlTransform(url))}
      components={MD_COMPONENTS}
    >
      {children}
    </ReactMarkdown>
  );
}
